import { Deserializable } from './deserializable';
import { ActivationCode } from './activationCode';


export class ActivationCodes implements Deserializable {
  codes: ActivationCode[];

  deserialize(input: any) {

    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
